__turbopack_context__.v({
  "container": "index-module__fT4U6q__container",
  "item": "index-module__fT4U6q__item",
  "root": "index-module__fT4U6q__root",
});
